<template>
    <div>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="购货方名称" prop="ghfmc" min-width="220"></el-table-column>            
            <el-table-column label="发票号码" prop="byzd1" min-width="220"></el-table-column>            
            <el-table-column label="价税合计金额" prop="kphjje" min-width="220"></el-table-column>            
            <el-table-column label="开票类型" prop="kplx" min-width="220">
                <template v-slot="scope">
                    {{scope.row.kblx === '0' ? '正常发票' : '红票'}}
                </template>
            </el-table-column>                
            
            <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="downloadHandler(scope.row)">下载发票</el-button>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/manage/finance/auditorder/dzfpdetail.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    components: { },
    data() {
        return {
            pgData: {
                sortname: 'b.fp_hm',
                sortorder: 'asc',

                issh: '1',
                txtKey3: '',
            },
        }
    },
    computed: {
        
    },
    methods: {
        downloadHandler(row) {
            window.location.assign(row.byzd2);
        }
    },
    created() {
        // this.jspInit(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/bdlist.json`, {
            
        // }, data => {
        //     this.jspDataInit(data, [
        //         'dwcode',
        //     ]);
        // });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    .table-info-row + .table-info-row{margin-top:.5em;}
</style>
